import angular from 'angular';
import template from './template.html';
import './style.scss';

export class ApplicantDetailsSection {
    $onInit() {
        this.showApplicantDetailsEdit = false;
    }
}

export const ApplicantDetailsSectionConfiguration = {
    template,
    bindings: {
        candidate: '<',
        canEdit: '<',
    },
    controller: ApplicantDetailsSection,
    controllerAs: 'applicantDetailsSectionController',
};

angular
    .module('TALENYA-FE')
    .component('candidateApplicantDetailsSection', ApplicantDetailsSectionConfiguration);
